<template>
    <div class="px-2 py-4 sm:px-4 sm:py-6 lg:px-8">
        <h1 class="text-3xl md:text-4xl lg:text-5xl text-center text-green-warm-500 my-0 pb-6 sm:pb-8">
            {{ $t('Let’s Get Started...') }}
        </h1>

        <div class="flex flex-col sm:flex-row items-start sm:items-center justify-between border-b border-t border-gray-400 py-8">
            <p class="sm:w-4/5 text-base lg:text-md text-gray-700 mb-6 sm:my-0 sm:pr-8 md:pr-16 lg:pr-32">
                {{ $t('Begin by adding information about yourself and your home office.') }} {{ $t('These details will be set on any new property transactions you create, and can be changed at any time in the') }} <a :href="route_settings" class="uppercase text-sm tracking-widest text-green-warm-600 hover:text-green-warm-500 mx-1">{{ $t('Settings') }}</a> {{ $t('section') }}.
            </p>

            <a :href="route_dashboard"
                class="ml-auto block uppercase tracking-widest border-2 bg-blue-100 hover:bg-blue-200 border-blue-500 hover:border-blue-600 px-8 py-4 text-blue-500 hover:text-blue-600 text-sm transition-all duration-150 flex-shrink-0"
            >
                {{ $t('Done with Setup') }} <i class="fas fa-arrow-right ml-2 -mr-2"></i>
            </a>
        </div>

        <div class="flex flex-col lg:flex-row items-start border-b border-gray-400 py-6 lg:py-10">
            <div class="lg:w-1/4 pt-2 lg:pr-6">
                <h2 class="text-2xl text-green-warm-600 pb-3">
                    {{ $t('Profile') }}
                </h2>

                <p class="text-base text-gray-warm-700 leading-snug">
                    {{ $t('Enter your contact and office information.') }}
                </p>
            </div>

            <div class="w-full pt-6 lg:pt-0 lg:w-3/4 lg:pl-10">
                <settings-contact-information-index
                    :accordion="false"
                    :include_discard_button="false"
                    :url="update_contact_info_url"
                    :broker="broker"
                    :settings="settings"
                    :email_editable="false"
                    :account_user_role="account_user_role"
                    @roleChanged="roleChanged"
                >
                </settings-contact-information-index>
            </div>
        </div>

        <div v-if="account_user_role === 'agent_or_broker'"
            class="flex flex-col lg:flex-row items-start border-b border-gray-400 py-6 lg:py-10"
        >
            <div class="lg:w-1/4 pt-2 lg:pr-6">
                <h2 class="text-2xl text-green-warm-600 pb-3">
                    {{ $t('Home Office Contacts') }}
                </h2>

                <p class="text-base text-gray-warm-700 leading-snug">
                    {{ $t('You can specify contacts from your office to be used as defaults for new property transactions, and who you would like to notify of new transactions you create.') }}
                </p>
            </div>

            <div class="w-full pt-6 lg:pt-0 lg:w-3/4 lg:pl-10">
                <settings-home-office-index
                    :accordion="false"
                    :include_discard_button="false"
                    :url="update_home_office_url"
                    :broker="broker"
                    :settings="settings"
                    :contacts_home_office_coordinator="contacts.home_office_coordinator"
                    :contacts_managing_broker="contacts.managing_broker"
                    :contacts_office_manager="contacts.office_manager"
                    :contacts_transaction_coordinator="contacts.transaction_coordinator"
                >
                </settings-home-office-index>
            </div>
        </div>

        <div class="flex items-center justify-end py-12">
            <a :href="route_dashboard"
                class="block uppercase tracking-widest border-2 bg-blue-100 hover:bg-blue-200 border-blue-500 hover:border-blue-600 px-8 py-4 text-blue-500 hover:text-blue-600 text-sm transition-all duration-150 flex-shrink-0"
            >
                {{ $t('Done with Setup') }} <i class="fas fa-arrow-right ml-2 -mr-2"></i>
            </a>
        </div>
    </div>
</template>

<script>
import SettingsContactInformationIndex from
    '../profile/settings/contact-information/contact-information-index.vue';
import SettingsHomeOfficeIndex from
    '../profile/settings/home-office/home-office-index.vue';

export default {
    components: {
        SettingsContactInformationIndex,
        SettingsHomeOfficeIndex,
    },

    props: {
        broker: {},
        settings: {},
        contacts: {},
        initial_account_user_role: {},
        update_contact_info_url: {},
        update_home_office_url: {},
        route_settings: {},
        route_dashboard: {},
    },

    data() {
        return {
            account_user_role: this.initial_account_user_role,
        }
    },

    methods: {
        roleChanged(role) {
            this.account_user_role = role;
        },
    },
}
</script>
